import { render, staticRenderFns } from "./informationModel.vue?vue&type=template&id=8acfcda8&scoped=true"
import script from "./informationModel.vue?vue&type=script&lang=js"
export * from "./informationModel.vue?vue&type=script&lang=js"
import style0 from "./informationModel.vue?vue&type=style&index=0&id=8acfcda8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acfcda8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8acfcda8')) {
      api.createRecord('8acfcda8', component.options)
    } else {
      api.reload('8acfcda8', component.options)
    }
    module.hot.accept("./informationModel.vue?vue&type=template&id=8acfcda8&scoped=true", function () {
      api.rerender('8acfcda8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/additionalFrom/informationModel.vue"
export default component.exports